import { Button } from 'antd';
import useAuthenticationCode from '../../hooks/useAuthenticationCode';
import { StrykerAlertColor } from 'osep-react-antd';
import config from '../../config';
import { useEffect } from 'react';
import { useAtlassianMeQuery } from '../../hooks/query/useAtlassianMeQuery';
import { ATLASSIAN_ME_KEY } from '../../utils/consts';
import { useQueryClient } from '@tanstack/react-query';
import { useAtlassianDisconnect } from '../../hooks/useAtlassianDisconnect';

type Props = { onAtlassianConnectedChange?: (connected: boolean) => void };

const AtlassianConnection = ({ onAtlassianConnectedChange }: Props) => {
  const queryClient = useQueryClient();
  const { startAuthentication } = useAuthenticationCode();
  const { data: atlassianIdentity, isLoading } = useAtlassianMeQuery();
  const { disconnectFromAtlassian } = useAtlassianDisconnect();

  useEffect(() => {
    if (!atlassianIdentity) {
      onAtlassianConnectedChange?.(true);
      return;
    }

    if (atlassianIdentity.status === 404) {
      onAtlassianConnectedChange?.(false);
    } else {
      onAtlassianConnectedChange?.(true);
    }
  }, [atlassianIdentity, onAtlassianConnectedChange]);

  const handleDisconnect = async () => {
    if (disconnectFromAtlassian) {
      await disconnectFromAtlassian();
      queryClient.invalidateQueries({ queryKey: [ATLASSIAN_ME_KEY] });
    }
  };

  if (isLoading) {
    return (
      <Button type="primary" block disabled>
        Connect to Atlassian
      </Button>
    );
  }

  if (atlassianIdentity?.status === 404) {
    return (
      <Button
        type="primary"
        block
        style={{
          backgroundColor: StrykerAlertColor.SUCCESS,
          borderColor: StrykerAlertColor.SUCCESS,
          color: 'white',
        }}
        disabled={!startAuthentication}
        onClick={() =>
          startAuthentication &&
          startAuthentication(
            `${config.atlassianUiAuthUrl}?audience=api.atlassian.com&client_id=${config.atlassianClientId}&response_type=code&prompt=consent&scope=${config.atlassianScopes}`,
            `${config.basePath}/atlassian/redirect-receiver`,
          )
        }
      >
        Connect to Atlassian
      </Button>
    );
  }

  return (
    <Button
      type="primary"
      block
      style={{
        backgroundColor: StrykerAlertColor.ERROR,
        borderColor: StrykerAlertColor.ERROR,
        color: 'white',
      }}
      disabled={!disconnectFromAtlassian}
      onClick={handleDisconnect}
    >
      Disconnect from Atlassian
    </Button>
  );
};
export default AtlassianConnection;
